<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                  <el-row>

                    <el-col :span="12" class="item">
                      <el-form-item label="商家" required prop="businessCode">
                        <el-select v-model="addForm.businessCode" placeholder="请选择商家" style="width: 100%">
                          <el-option
                              v-for="item in arr_business"
                              :key="item.businessCode"
                              :label="item.name"
                              :value="item.businessCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>


                      <el-col :span="12" class="item">
                          <el-form-item label="名称" required prop="name">
                              <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="排序" required prop="sort">
                              <el-input v-model.number="addForm.sort" placeholder="请输入排序"></el-input>
                          </el-form-item>
                      </el-col>
                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['arr_business'],
        data() {
            return {
                loading: false,


                addForm:{
                    timeStr:timeStr,
                  sign:'',
                    staffCode:getStaffCode(),
                  businessCode:'',

                    name:'',
                    sort:'',
                },

                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                        { type: 'number', message: '排序必须为数字值'}
                    ],
                  businessCode:[
                    { required: true, message: '请选择商家', trigger: 'blur' },
                  ],
                },


            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();

            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClassBusiness/GovAddBus",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )

            },


        }
    }


</script>

<style lang="scss" scoped>

</style>
